/** Mapbox Geocoding API v6 reverse endpoint. */
export const MAPBOX_GEOCODE_V6_REVERSE_URL =
	"https://api.mapbox.com/search/geocode/v6/reverse";

/** Mapbox Geocoding API v6 forward endpoint. */
export const MAPBOX_GEOCODE_V6_FORWARD_URL =
	"https://api.mapbox.com/search/geocode/v6/forward";

export const getMapboxAccessToken = (): string | undefined =>
	import.meta.env.VITE_MAPBOX_TOKEN;

/** Custom Atlas street styles */
export const MAPBOX_LIGHT_STREET_STYLE =
	"mapbox://styles/atlasdevops/cmj93uti0002j01shd0wp67xk";
export const MAPBOX_DARK_STREET_STYLE =
	"mapbox://styles/atlasdevops/cmt3j7spz004401syefjo2bat";

/** Mapbox satellite streets styles */
export const MAPBOX_LIGHT_SATELLITE_STYLE =
	"mapbox://styles/mapbox/satellite-streets-v12";
export const MAPBOX_DARK_SATELLITE_STYLE =
	"mapbox://styles/mapbox/satellite-streets-v12";
